import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch } from "react-redux";
import { pendingAction } from "store/slice/dealersSlice";
import Popconfirm from "components/Popconfirm/Popconfirm";
import { formatDate } from "helpers/dates";

// Function to format date

// Function to format studios and values
const formatStudios = (studiosValues = {}, studios = []) => {
  const formattedStudios = Object.entries(studiosValues)
    .map(([studioId, value]) => {
      const studioName = studios.find((s) => s.id == studioId)?.name;
      return studioName ? `• ${studioName}: ${value}` : null;
    })
    .filter(Boolean)
    .join("\n");

  return formattedStudios || "N/A";
};

export default function data({ history = [], dispatch, handleViewClick, handleDeleteClick }) {
  const shiftConf = history?.shiftConf || [];
  const studios = history?.studios || [];

  const rows = shiftConf.map((shift) => ({
    startDate: formatDate(shift?.startDate),
    endDate: formatDate(shift?.endDate),
    studios: (
      <MDBox component="pre" fontSize="large" whiteSpace="pre-wrap">
        {formatStudios(shift?.studiosValues, studios)}
      </MDBox>
    ),
    view: (
      <MDBox display="flex" gap={1}>
        <IconButton color="blue" onClick={() => handleViewClick(shift)}>
          <VisibilityIcon />
        </IconButton>
        <Popconfirm
            title="Are you sure you want to delete this shift?"
            onConfirm={() => handleDeleteClick(shift)}
        >
          <IconButton color="error">
            <i className="material-icons">delete</i>
          </IconButton>
        </Popconfirm>
      </MDBox>
    ),
  }));

  return {
    columns: [
      { Header: "Start Date", accessor: "startDate", align: "left" },
      { Header: "End Date", accessor: "endDate", align: "left" },
      { Header: "Studios", accessor: "studios", align: "left", width: "45%" },
      { Header: "View", accessor: "view", align: "center" },
    ],
    rows,
  };
}
